import http from 'hub-http/clients/apiClient';
import { convertToUnixEpoch } from './util';
export async function fetchCurrentUsage() {
  const data = await http.get('enrichment-platform-ubb-proxy/v2/usage-period-usage/real-time');
  if (data['@result'] !== 'OK' || !data.recurringUsage) {
    throw new Error('This portal has no usage plan');
  }
  const {
    updatedAt,
    recurringUsage,
    available,
    overage,
    overageEnabled
  } = data;
  const nonRecurringUsage = data.nonRecurringUsage[0];
  return {
    availableCredits: available,
    totalOverage: overage,
    isOverageEnabled: overageEnabled,
    monthlyCredits: {
      totalUsage: recurringUsage.used,
      usageLimit: recurringUsage.limit,
      updatedAt,
      usagePeriod: {
        startDate: convertToUnixEpoch(recurringUsage.startDate),
        endDate: convertToUnixEpoch(recurringUsage.endDate)
      }
    },
    oneTimeCredits: nonRecurringUsage ? {
      totalUsage: nonRecurringUsage.used,
      usageLimit: nonRecurringUsage.limit,
      updatedAt,
      usagePeriod: {
        startDate: convertToUnixEpoch(nonRecurringUsage.startDate),
        endDate: convertToUnixEpoch(nonRecurringUsage.endDate)
      }
    } : undefined
  };
}